// JsFromRoutes CacheKey d8cd36c6a01ee6d60ba8f93b4f158a71
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  adoptionAgreement: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/adoption_agreement'),
  adoptionAgreementWithExecution: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/adoption_agreement_with_execution'),
  creditableCoverageDisclosure: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/creditable_coverage_disclosure'),
  ichraNotice: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/ichra/notice'),
  ichraPlan: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/ichra/plan'),
  ichraSummaryPlanDescription: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/ichra/summary_plan_description'),
  planDescription: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/plan_description'),
  sbc: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/sbc'),
  section125PremiumOnlyPlan: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/section125/premium_only_plan'),
  section125SummaryPlanDescription: /* #__PURE__ */ definePathHelper('get', '/members/plan_documents/:plan_year/section125/summary_plan_description'),
}
